import * as jquery from 'jquery';
import * as q from 'q';
import * as globalConfig from 'globalConfig';

export const Deps = {
    $: jquery
}

interface RequestVerificationTokenResult {
    Token: string
}

export namespace AntiForgeryService {
    export function generateAntiForgeryTokenHeaders(existingHeaders?: { [key: string]: string }): Q.Promise<any> {
        existingHeaders = existingHeaders ? existingHeaders : {};
        const op = q.defer<{ [key: string]: string }>();

        Deps.$.ajax({
            url: globalConfig.Urls.Script.CSRFToken,
            method: 'GET',
            success: (result: RequestVerificationTokenResult) => {
                const newHeaders = { ...existingHeaders };
                newHeaders['RequestVerificationToken'] = result.Token;
                op.resolve(newHeaders);
            },
            error: (e: any) => {
                op.reject(e);
            }
        });

        return op.promise;
    }

    export function appendAntiForgeryTokenHeaders(request: JQuery.AjaxSettings): any {
        const token = Deps.$('input[name="__RequestVerificationToken"]').val();

        const data = request.data === null ? {} : { ...request.data as any };
        data['__RequestVerificationToken'] = token;
        request.data = data;
        
        return request;
    }
}